import Header from "./Header";
import Footer from "./Footer";
import bgImage from "../assets/lay.webp";

export default function Layout({ children }) {
  return (
    <div className="relative min-h-screen flex flex-col bg-[#0a0a0f] overflow-hidden">

      {/* GLOBAL BACKGROUND IMAGE */}
      <div className="fixed inset-0 -z-10">
        <img
          src={bgImage}
          alt=""
          className="w-full h-full object-cover opacity-20 scale-105 blur-[1.5px]"
        />

        {/* Dark overlay for contrast */}
        <div className="absolute inset-0 bg-[#0a0a0f]/80" />
      </div>

      {/* Header */}
      <Header />

      {/* Page Content */}
      <main className="flex-1 pt-20 relative z-10">
        {children}
      </main>

      {/* Footer */}
      <Footer />

    </div>
  );
}
